import React, { useEffect } from 'react';

const ConfirmDialog = ({ show, message, onConfirm, onCancel }) => {
  useEffect(() => {
    if (show) {
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          onCancel();
        }
      };
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when dialog is open
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleEscape);
        document.body.style.overflow = 'unset';
      };
    }
  }, [show, onCancel]);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001,
        animation: 'fadeIn 0.2s ease-out'
      }}
      onClick={(e) => {
        // Close on backdrop click
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div
        style={{
          background: 'var(--bgSecondary)',
          border: '1px solid var(--borderPrimary)',
          borderRadius: '2px', // Nearly sharp
          padding: '30px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.7)',
          animation: 'slideUp 0.3s ease-out',
          zIndex: 10002
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          style={{
            color: '#fff',
            marginTop: 0,
            marginBottom: '20px',
            fontSize: '16px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            borderBottom: '1px solid var(--borderSecondary)',
            paddingBottom: '10px'
          }}
        >
          Confirm Action
        </h3>

        <p
          style={{
            color: 'var(--textPrimary)',
            marginBottom: '30px',
            fontSize: '14px',
            lineHeight: '1.6'
          }}
        >
          {message}
        </p>

        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}
        >
          <button
            onClick={onCancel}
            type="button"
            style={{
              padding: '10px 20px',
              background: 'var(--bgPrimary)',
              color: 'var(--textSecondary)',
              border: '1px solid var(--borderSecondary)',
              borderRadius: '0',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 600,
              textTransform: 'uppercase',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#fff';
              e.currentTarget.style.borderColor = '#475569';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--textSecondary)';
              e.currentTarget.style.borderColor = 'var(--borderSecondary)';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            type="button"
            style={{
              padding: '10px 20px',
              background: '#7f1d1d',
              color: '#fca5a5',
              border: '1px solid #991b1b',
              borderRadius: '0',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 600,
              textTransform: 'uppercase',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#991b1b';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#7f1d1d';
            }}
          >
            Confirm
          </button>
        </div>
      </div>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ConfirmDialog;
